import Backbone from "backbone";
import $ from "jquery";

export default Backbone.View.extend({

        events: {
            "change .js-checkOptionalSelect": "checkOptional",
        },

        initialize: function () {
            this.checkOptional();
        },

        checkOptional: function () {
            var result = $("#Entreprise_CompanyType").val();
            if (result == 1 /*entreprise*/ || result == 7 /*divers*/) {
                $(".f-form-label--optionalSiret").hide();
                $(".f-form-label--optionalVat").show();
            }
            else if (result == 9 /*entreprise etrangere*/) {
                $(".f-form-label--optionalSiret").show();
                $(".f-form-label--optionalVat").hide();
            }
            else {
                $(".f-form-label--optionalSiret").show();
                $(".f-form-label--optionalVat").show();
            }
        }
    });
